import jifen from '../views/jifen'

export default {
  path: '/jifen',
  component: jifen,
  redirect: '/jifen/rules',
  name: 'Jifen',
  meta: {
    title: '积分管理'
  },
  children: [
    {
      path: '/jifen/rules',
      component: () => import('@/views/jifen/Rules'),
      name: 'JifenRules',
      meta: { title: '积分规则' }
    },
    {
      path: '/jifen/accounts',
      component: () => import('@/views/jifen/Accounts'),
      name: 'JifenAccounts',
      meta: { title: '积分账户' }
    },
    {
      path: '/jifen/flows',
      component: () => import('@/views/jifen/Flows'),
      name: 'JifenFlows',
      meta: { title: '积分流水' }
    },
    {
      path: '/jifen/exchange',
      component: () => import('@/views/jifen/ExchangeOrders'),
      name: 'JifenExchange',
      meta: { title: '积分兑换订单' }
    },
    {
      path: '/jifen/referral',
      component: () => import('@/views/jifen/ReferralRecords'),
      name: 'JifenReferral',
      meta: { title: '推荐奖励记录' }
    }
  ]
}
